import type { NodeParameters } from '../../../types/node-properties';

/**
 * Default parameter values for Execute Workflow Tool node
 */
const defaults: NodeParameters = {
  workflowId: '',
  toolName: '',
  toolDescription: '',
  inputSchema: '{}',
  advancedOptions: false,
};

export default defaults;
